import QuestionGeneration from './QuestionGeneration'

import './style.scss'

export { QuestionGeneration }
export default QuestionGeneration
